module.exports = __webpack_public_path__ + "static/media/Adobe_logo_and_wordmark_(2017).ae551bab.svg";